import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_mentor_profile_data_action,
  get_job_changes_notification_action,
  update_user_meta_data_action,
  get_all_assessment_kits_data_action,
  search_candidate_action,
} from "../../../redux/_actions";
import { showSuccessMessage, showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
import { appRoutes } from "../../../_routes/app-routes";

function useMentorDashboar(props) {
  const [assessmentKits, setAssessmentKits] = useState([]);
  const [assesmentKitsLoading, setAssessmentKitsLoading] = useState(false);
  const [mentorProfile, setMentorProfile] = useState({});
  const [resumeUploadModal, setResumeUploadModal] = useState(false);
  const [isResumeUpload, setIsResumeUpload] = useState(false);
  const [suggestedCandidatesLoading, setSuggestedCandidatesLoading] =
    useState(false);
  const [suggestedCandidates, setSuggestedCandidates] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { allPublishedAssessmentData } = useSelector(
    (state) => state.get_all_assessment_kits_data_reducer
  );

  const { mentorProfileData } = useSelector(
    (state) => state.get_mentor_profile_data_reducer
  );

  const { suggestedCandidatesData } = useSelector(
    (state) => state.get_suggested_candidates_hiring_manager_reducer
  );
  useEffect(() => {
    getAssessmentKits("publish");
    callJobChangesNotificationsApi();
    getSuggestedCandidatesApi();
  }, []);

  useEffect(() => {
    if (mentorProfileData?.data) {
      setMentorProfile(mentorProfileData?.data);
    }
  }, [mentorProfileData]);

  useEffect(() => {
    if (allPublishedAssessmentData) {
      setAssessmentKits(allPublishedAssessmentData);
    }
  }, [allPublishedAssessmentData]);

  useEffect(() => {
    if (suggestedCandidatesData?.data) {
      let results = suggestedCandidatesData?.data;
      setSuggestedCandidates(results);
    }
  }, [suggestedCandidatesData]);


  const getSuggestedCandidatesApi = async () => {
    const data = {
      index: "candidate_profile",
      search_key: "",
      search: "",
      skill_names: "",
    };
    setSuggestedCandidatesLoading(true);
    const res = await dispatch(search_candidate_action(data));
    setSuggestedCandidates(res);
    setSuggestedCandidatesLoading(false);
  };

  const getAssessmentKits = async (type) => {
    setAssessmentKitsLoading(true);
    await dispatch(get_all_assessment_kits_data_action(type));
    await dispatch(get_mentor_profile_data_action());
    setAssessmentKitsLoading(false);
  };

  const onEditKitClick = (id) => {
    navigate(appRoutes.assessementKit.viewAssessment.replace(":id", id));
  };

  const onViewAssessmentsClick = () => {
    navigate("/assessment/assessment-kits");
  };
  const onViewCandidatesClick = (interviewKit) => {
    navigate(`/assessment/view-candidates/${interviewKit}`);
  };

  const callJobChangesNotificationsApi = async () => {
    await dispatch(get_job_changes_notification_action());
  };

  const onResumeUpload = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      if (file && file.type === "application/pdf") {
        setIsResumeUpload(true);
        await dispatch(update_user_meta_data_action(data));
        handleResumeUploadModal(false);
        setIsResumeUpload(false);
      } else {
        showWarningMessage("Please select a PDF file.");
      }
    } else {
      showWarningMessage("Resume Need to Uploaded");
    }
  };

  const handleResumeUploadModal = (type) => {
    setResumeUploadModal(type);
  };

  const onClickNewAssessment = () => {
    navigate(appRoutes.assessementKit.createAssessment);
  };

  const onViewAllCandidatesClick = () => {
    navigate(`/all-candidates`);
  };

  const onViewCandidateProfileClick = (id) => {
    if (id) navigate(`/view-candidate-profile/${id}`, { state: id });
  };
  const onShareProfileClick = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000/mentor-profile/${
          mentorProfile?.user_details &&
          mentorProfile.user_details?.hash_id
        }`
      : `${process.env.REACT_APP_DEV_ROOT_URL}/mentor-profile/${
          mentorProfile?.user_details &&
          mentorProfile.user_details?.hash_id
        }`;
    window.navigator.clipboard.writeText(url);

    showSuccessMessage(`Url copied ${url}`);
  };

  return {
    assessmentKits,
    assesmentKitsLoading,
    mentorProfile,
    resumeUploadModal,
    isResumeUpload,
    suggestedCandidates,
    suggestedCandidatesLoading,

    onEditKitClick,
    onViewAssessmentsClick,
    onViewCandidatesClick,
    handleResumeUploadModal,
    onResumeUpload,
    onClickNewAssessment,
    onViewAllCandidatesClick,
    onViewCandidateProfileClick,
    onShareProfileClick
  };
}
export default useMentorDashboar;